/**
 * @module project/container/entry_details
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import findIndex from 'lodash/findIndex';
import EntryDetails from 'project/components/entry_details';
import { getProject, toggleViolationModal } from 'project/ducks/project';
import {
  resetZoom, getEntryModalState, zoomInEntry,
  zoomOutEntry, deleteEntry, getProjectEntriesState, toggleEntryDelete,
  toggleEntryReinstate, dismissFeedback
} from 'project/ducks/entries';
import { scoreRevision, getRevisionsComments, fetchComments } from 'project/ducks/revisions';
import { toggleRemoveModal } from 'project/ducks/creatives';
import {
  canViewEntryDetailsPager, canViewWithdrawn, canViewRevisions, isCollaborator
} from 'project/utils';
import {
  canReportViolation, canComment, canRate, canWithdraw, canUnwithdraw, canEliminate,
  canUneliminate, canViewAssetPrice, canRemoveCreative, canViewRating, canSendInternalComment,
  canSendInternalCommentOnly
} from 'entries/utils';
import { updateRevision } from 'single_entry/ducks';

const getPermissions = (state, currentSelectedEntry) => {
  const user = state.user.profile_data;
  const project = getProject(state);
  const entry = currentSelectedEntry;

  if (!entry) {
    return {};
  }

  return {
    canComment: canComment({ user, project, entry }),
    canSendInternalComment: canSendInternalComment({ user, project }),
    canSendInternalCommentOnly: canSendInternalCommentOnly({ user, project }),
    canReportViolation: canReportViolation({ user, project, entry }),
    canRate: canRate({ user, project, entry }),
    canWithdraw: canWithdraw({ user, entry }),
    canUnwithdraw: canUnwithdraw({ user, entry }),
    canEliminate: canEliminate({ entry, user, project }),
    canUneliminate: canUneliminate({ entry, user, project }),
    canViewAssetPrice: canViewAssetPrice({ entry, user, project }),
    canRemoveCreative: canRemoveCreative({ user, project }),
    canViewScore: canViewRating({ project, entry, user }),
    canViewDetailsPager: canViewEntryDetailsPager(state),
    canViewWithdrawn: canViewWithdrawn(state, null, currentSelectedEntry),
    canViewRevisions: canViewRevisions(state, null, currentSelectedEntry),
    isClient: user.id === project.client,
    isCollaborator: isCollaborator(project),
    hasCollaborators: project.collaboration_allowed
  };
};

function mapStateToProps(state, { entry }) {
  const entryState = getEntryModalState(state);
  const entriesViewState = getProjectEntriesState(state);
  const entryIds = state.single_entry.entryIds;
  const entryIndex = findIndex(entryIds, id => id === entry.id);

  return {
    itemsCount: entryIds.length,
    currentPage: entryIndex + 1,
    project: getProject(state),
    comments: getRevisionsComments(state),
    entryState,
    scoredRevision: entriesViewState.scoredRevision,
    currentGalleryPage: entriesViewState.currentPage,
    user: state.user,
    permissions: getPermissions(state, entry)
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    scoreRevision,
    zoomInEntry,
    zoomOutEntry,
    resetZoom,
    fetchComments,
    deleteEntry,
    toggleRemoveCreativeModal: toggleRemoveModal,
    toggleEntryDelete,
    toggleEntryReinstate,
    onChangeRevision: updateRevision,
    toggleViolationModal,
    dismissFeedback
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EntryDetails));



// WEBPACK FOOTER //
// ./single_entry/containers/details_wrapper.jsx